// Place this in a file like src/utils/errorSuppressionUtils.js

/**
 * This utility suppresses specific ApexCharts errors in the console
 * by intercepting console.error calls and filtering them
 */
export const suppressApexChartsErrors = () => {
  // Store the original console.error
  const originalConsoleError = console.error;

  // Override console.error to filter out specific errors
  console.error = function (...args) {
    // Check if the error message contains the specific ApexCharts error
    const errorMessage = args.join(" ");

    if (
      (typeof errorMessage === "string" &&
        (errorMessage.includes(
          "Cannot read properties of undefined (reading '0')"
        ) ||
          errorMessage.includes("apexcharts"))) ||
      (args[0] &&
        args[0].message &&
        (args[0].message.includes(
          "Cannot read properties of undefined (reading '0')"
        ) ||
          (args[0].stack && args[0].stack.includes("apexcharts"))))
    ) {
      // Suppress this specific error
      return;
    }

    // For all other errors, call the original console.error
    originalConsoleError.apply(console, args);
  };

  // Return a function to restore the original console.error if needed
  return () => {
    console.error = originalConsoleError;
  };
};

/**
 * Higher-order function that wraps a React component's render function
 * with a try-catch block to suppress specific errors
 */
export const withErrorSuppression = (Component) => {
  const WrappedComponent = (props) => {
    try {
      return <Component {...props} />;
    } catch (error) {
      // Check if this is the specific ApexCharts error we want to suppress
      if (
        error.message.includes("Cannot read properties of undefined") ||
        error.stack.includes("apexcharts")
      ) {
        // Return fallback content
        return (
          <div className="w-full h-full flex items-center justify-center">
            <div className="animate-pulse">Loading chart...</div>
          </div>
        );
      }

      // Re-throw any other errors
      throw error;
    }
  };

  WrappedComponent.displayName = `WithErrorSuppression(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};
